import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { FluidList } from 'Components/Styles/Lists/FluidList';
import ListLinkRow from 'Components/Parts/Lists/ListLinkRow';
import { Page } from 'Constants/constants';

// TODO: When clicking on team, scroll to the team section of the home page
export default function () {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <FluidList>
            <ListLinkRow
                text={t('aboutSettingsPage.teamText')}
                onClick={() => history.push(Page.HELP)}
                showArrow
            />
            <ListLinkRow
                text={t('aboutSettingsPage.privacyPolicyText')}
                onClick={() => history.push('/dashboard/settings/privacy')}
                showArrow
            />
            <ListLinkRow
                text={t('aboutSettingsPage.termsText')}
                onClick={() => history.push('/dashboard/settings/terms')}
                showArrow
            />
            <ListLinkRow
                text={t('aboutSettingsPage.softwareVersionText')}
                onClick={() => history.push(Page.SOFTWARE_VERSION)}
                showArrow
            />
        </FluidList>
    );
}
